export default __webpack_public_path__ + "static/media/menu_photo2@2x.06049efd.png";